<template>
    <div
        :style="{backgroundImage: 'url(' + $store.state.settings.background + ')'}"
        class="bg-center bg-no-repeat bg-cover items-center"
    >
        <div class="container mx-auto">
            <div class="h-full min-h-screen flex">
                <div class="w-full m-auto">
                    <div class="flex justify-center">
                        <div class="w-full max-w-md bg-white shadow-md rounded p-10 my-10">
                            <router-link class="flex items-center justify-center mb-8" to="/">
                                <img v-bind:src="'https://firebasestorage.googleapis.com/v0/b/lesodec-a5808.appspot.com/o/lesodec%20(2).jfif?alt=media&token=cdbf25d0-3c29-4b8e-bf0e-fac10e9d0a89'" alt="icon" class="h-8 w-auto mr-4 rounded-full"/>
                                <div class="font-medium self-center text-xl sm:text-2xl uppercase text-gray-800">{{ $store.state.settings.name }}</div>
                            </router-link>
                            <router-view/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "auth",
    metaInfo() {
        return {
            titleTemplate: '%s - ' + this.$store.state.settings.name
        }
    },
}
</script>
